export class ZipApiError extends Error {
  constructor(public response: Response, message?: string) {
    super(message || `${response.status} ${response.statusText}`);
  }
}
